import { ChevronDown } from "lucide-react";
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { claseCampo } from "./input";

export interface SelectNativoProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /**
   * Va al contenedor (ancho, margen), no al `<select>`: el select siempre llena
   * el contenedor y la flecha se posiciona respecto de el.
   */
  className?: string;
}

/**
 * `<select>` nativo con la piel de `Input`. Para formularios: en el celular abre
 * el picker del sistema y con teclado es mas rapido que un listbox. El `Select`
 * de Radix queda para filtros con busqueda o muchas opciones.
 *
 * `appearance-none` saca la flecha del navegador (distinta en cada uno) y la
 * repone Lucide; `pr-9` reserva el lugar.
 */
export const SelectNativo = forwardRef<HTMLSelectElement, SelectNativoProps>(
  ({ className, children, ...props }, ref) => (
    <div className={cn("relative", className)}>
      <select
        ref={ref}
        className={cn(claseCampo, "peer h-11 cursor-pointer appearance-none pr-9 sm:h-10")}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground peer-disabled:opacity-50"
        aria-hidden="true"
      />
    </div>
  ),
);
SelectNativo.displayName = "SelectNativo";
